import axios from "@/libs/api.request";
// 获取小包绩效列表
export const getPerformance = params => {
  return axios.request({
    url: "/report/achievements/customerservice",
    method: "get",
    params
  });
};

// 导出绩效列表
export const exportPerformance = params => {
  return axios.request({
    url: "/report/achievements/customerservicelog",
    method: "GET",
    params
  });
};
